// extracted by mini-css-extract-plugin
export default {"Logos":"styles_Logos__dBNEG","Logos-items":"styles_Logos-items__C-vZt"};